import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Link, useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ThinAdminIcon, ThinChevronRight, ThinCloudDownloadIcon} from "../../../components/icons/material-icons";

export const AdminSettingsScreen = () => {
    const [data,setData] = useState({
        loaded:false,
        canUsers:false,
    });
    const navigate = useNavigate();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/settings/overview',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                users:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setData({
                    loaded: true,
                    canUsers: d.users,
                });
            },
            () => {},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
        document.title = 'تنظیمات | نهال';
    }, []);
    const generateBackup = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/settings/backup',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                data:string,
                now:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                var a = encodeURI('data:text/plain;charset=UTF-8,' + d.data);
                var link = document.createElement('a');
                link.setAttribute('href', a);
                link.setAttribute('download', 'backup-' + d.now + ".ar3b");
                document.body.appendChild(link);
                link.click();
                ShowSnackbar(
                    'فایل بکاپ دانلود شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'تنظیمات', url: '/admins/settings'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>تنظیمات</b>
                                    </div>
                                    {
                                        data.canUsers ?
                                            <Link to="/admins/settings/users" className="normal-list-tile">
                                                <div>
                                                    <i><ThinAdminIcon/></i>
                                                    <div>
                                                        <b>مدیریت کاربران</b>
                                                        <span>مدیریت کاربران بخش مدیریت اتوماسیون مدرسه.</span>
                                                    </div>
                                                </div>
                                                <ThinChevronRight/>
                                            </Link> : null
                                    }
                                    <button className="normal-list-tile" onClick={generateBackup}>
                                        <div>
                                            <i><ThinCloudDownloadIcon/></i>
                                            <div>
                                                <b>دریافت بکاپ</b>
                                                <span>ایجاد یک خروجی بکاپ از تمام اطلاعات سامانه.</span>
                                            </div>
                                        </div>
                                        <ThinChevronRight/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};